"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppCrypt = void 0;
var Base58_1 = require("./libs/Base58");
var Qora_1 = require("./libs/Qora");
var tweetnacl_1 = require("tweetnacl");
var crypto_1 = require("crypto");
var bip39 = require('bip39');
var AppCrypt = /** @class */ (function () {
    function AppCrypt() {
    }
    /** @description Generate pass code by bip39.
     * @return {Promise<string>}
     */
    AppCrypt.generatePasscode = function () {
        bip39.setDefaultWordlist('english');
        return bip39.generateMnemonic();
    };
    /** @description Generate seed.
     * @return {Promise<string>}
     */
    AppCrypt.generateSeed = function () {
        return __awaiter(this, void 0, void 0, function () {
            var phrase, byteSeed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phrase = AppCrypt.generatePasscode();
                        byteSeed = AppCrypt.sha256(AppCrypt.sha256(phrase));
                        return [4 /*yield*/, Base58_1.Base58.encode(byteSeed)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /** @description Generate account seed.
     * @param {string | Int8Array} seed Seed.
     * @param {number} nonce Nonce.
     * @return {Promise<string>}
     */
    AppCrypt.generateAccountSeed = function (seed, nonce) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Qora_1.Qora.generateAccountSeed(seed, nonce)];
            });
        });
    };
    /** @description Gets key pair from seed.
     * @param {string | Int8Array} seed Seed.
     * @return {Promise<SignKeyPair>} Tweetnacl type.
     */
    AppCrypt.getKeyPairFromSeed = function (seed) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof seed === 'string')) return [3 /*break*/, 2];
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, Base58_1.Base58.decode(seed)];
                    case 1:
                        seed = new (_a.apply(Uint8Array, [void 0, _b.sent()]))();
                        _b.label = 2;
                    case 2: return [2 /*return*/, tweetnacl_1.sign.keyPair.fromSeed(seed)];
                }
            });
        });
    };
    /** @description SHA256 algorithm.
     * @param {Buffer | string | Int8Array} input Input value.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.sha256 = function (input) {
        if (typeof input === 'string') {
            return new Int8Array(crypto_1.createHash('sha256')
                .update(input)
                .digest());
        }
        if (input instanceof Int8Array) {
            return AppCrypt.sha256(new Buffer(input));
        }
        var hash = crypto_1.createHash('SHA256');
        hash.end(input);
        return new Int8Array(hash.read());
    };
    /** @description SHA256 algorithm.
     * @param {Buffer | string | Int8Array} input Input value.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.sha256big = function (input) {
        //console.log({ input });
        var hash = crypto_1.createHash('SHA256');
        var position = 0;
        var bufferSize = 1048576;
        var size = input.length;
        while (position < size) {
            var unitsize = size - position >= bufferSize ? bufferSize : size - position;
            var buffer = input.slice(position, position + unitsize);
            //console.log({ size, position, unitsize, buffer });
            hash.update(buffer);
            position += unitsize;
        }
        hash.end();
        return new Int8Array(hash.read());
    };
    /** @description Create new erachain address.
     * @return {Promise<string>}
     */
    AppCrypt.createAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                keys = AppCrypt.generateKeys();
                return [2 /*return*/, Qora_1.Qora.getAccountAddressFromPublicKey(new Int8Array(keys.publicKey))];
            });
        });
    };
    /** @description Gets short address.
     * @param {Int8Array | string} address Address.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.shortAddress = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var array_addr, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(typeof address === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(address)];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = address;
                        _b.label = 3;
                    case 3:
                        array_addr = _a;
                        return [2 /*return*/, array_addr.slice(1, 21)];
                }
            });
        });
    };
    /** @description Gets address from public key.
     * @param {Int8Array} key Public key.
     * @return {Promise<string>}
     */
    AppCrypt.getAccountAddressFromPublicKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Qora_1.Qora.getAccountAddressFromPublicKey(key)];
            });
        });
    };
    /** @description Generate new key pair.
     * @return {Promise<SignKeyPair>}
     */
    AppCrypt.generateKeys = function () {
        return tweetnacl_1.sign.keyPair();
    };
    /** @description Signing message.
     * @param {Int8Array} message Message to sign.
     * @param {Int8Array} secretKey Private key.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.sign = function (message, secretKey) {
        var result = tweetnacl_1.sign.detached(new Uint8Array(message), new Uint8Array(secretKey));
        return new Int8Array(result);
    };
    /** @description Verify sign.
     * @param {Int8Array} message Message to sign.
     * @param {Int8Array} result Result.
     * @param {Int8Array} publicKey Public key.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.verifySign = function (message, result, publicKey) {
        return tweetnacl_1.sign.detached.verify(new Uint8Array(message), new Uint8Array(result), new Uint8Array(publicKey));
    };
    AppCrypt.getAddressByPublicKey = function (publicKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof publicKey === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(publicKey)];
                    case 1:
                        publicKey = _a.sent();
                        _a.label = 2;
                    case 2:
                        publicKey = new Int8Array(publicKey);
                        return [2 /*return*/, Qora_1.Qora.getAccountAddressFromPublicKey(publicKey)];
                }
            });
        });
    };
    /** @description Gets address from private key.
     * @param {Int8Array | string} secretKey Private key.
     * @return {Promise<string>}
     */
    AppCrypt.getAddressBySecretKey = function (secretKey) {
        return __awaiter(this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof secretKey === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(secretKey)];
                    case 1:
                        secretKey = _a.sent();
                        _a.label = 2;
                    case 2:
                        keys = tweetnacl_1.sign.keyPair.fromSecretKey(new Uint8Array(secretKey));
                        return [2 /*return*/, AppCrypt.getAddressByPublicKey(new Int8Array(keys.publicKey))];
                }
            });
        });
    };
    /** @description Gets public key from private key.
     * @param {Int8Array | string} secretKey Private key.
     * @return {Promise<Int8Array>}
     */
    AppCrypt.getPublicKeyBySecretKey = function (secretKey) {
        return __awaiter(this, void 0, void 0, function () {
            var keys;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof secretKey === 'string')) return [3 /*break*/, 2];
                        return [4 /*yield*/, Base58_1.Base58.decode(secretKey)];
                    case 1:
                        secretKey = _a.sent();
                        _a.label = 2;
                    case 2:
                        keys = tweetnacl_1.sign.keyPair.fromSecretKey(new Uint8Array(secretKey));
                        return [2 /*return*/, new Int8Array(keys.publicKey)];
                }
            });
        });
    };
    AppCrypt.HASH_LENGTH = 32;
    return AppCrypt;
}());
exports.AppCrypt = AppCrypt;
